<template>
  <div class="login-landing-page">
    <!-- 固定导航栏 -->
    <div class="fixed-navbar">
      <div class="navbar-content">
          <div class="logo-section">
          <h1 class="logo-text">智拓星</h1>
          <span class="logo-subtitle">智能销售管理系统</span>
          </div>
        <div class="nav-actions">
          <el-button type="primary" class="login-btn-nav" @click="scrollToLogin">
            立即登录
          </el-button>
        </div>
      </div>
    </div>

    <!-- 星光背景粒子效果 -->
    <div class="stars-background">
      <div v-for="i in 50" :key="i" class="star" :style="getStarStyle(i)"></div>
    </div>

    <!-- 第一屏：Hero区域 - 以智慧拓客、与星光同行 -->
    <section class="hero-section" ref="heroSection">
      <div class="hero-content">
        <div class="hero-text-wrapper">
          <h1 class="hero-title">
            <span class="title-line-1">以智慧拓客</span>
            <span class="title-line-2">与星光同行</span>
          </h1>
          <p class="hero-subtitle">智能拓展客户群体 · 赋能销售全流程</p>
          <p class="hero-description">
            汇聚智慧之光，点亮销售之路。用数据驱动决策，用流程规范管理，<br>
            让每一次客户接触都成为成功的机会，让每一份努力都闪耀星光。
          </p>
<!--          <div class="hero-stats">-->
<!--            <div class="stat-item">-->
<!--              <div class="stat-number">1000+</div>-->
<!--              <div class="stat-label">企业信赖</div>-->
<!--            </div>-->
<!--            <div class="stat-item">-->
<!--              <div class="stat-number">50万+</div>-->
<!--              <div class="stat-label">客户管理</div>-->
<!--            </div>-->
<!--            <div class="stat-item">-->
<!--              <div class="stat-number">99.9%</div>-->
<!--              <div class="stat-label">系统稳定</div>-->
<!--            </div>-->
<!--          </div>-->
        </div>
        <div class="hero-visual">
          <div class="glow-orb orb-1"></div>
          <div class="glow-orb orb-2"></div>
          <div class="glow-orb orb-3"></div>
          <div class="network-visual">
            <div class="network-node" v-for="i in 12" :key="i" :style="getNodeStyle(i)"></div>
            <div class="network-lines"></div>
          </div>
        </div>
      </div>
      <div class="scroll-indicator">
        <div class="scroll-mouse">
          <div class="scroll-wheel"></div>
        </div>
        <span class="scroll-text">向下滚动探索更多</span>
      </div>
    </section>

    <!-- 第二屏：核心功能展示 -->
    <section class="features-section" ref="featuresSection">
      <div class="section-container">
        <div class="section-header">
          <h2 class="section-title">核心功能</h2>
          <p class="section-subtitle">四大核心模块，全面赋能销售管理</p>
        </div>
        <div class="features-grid">
          <div 
            v-for="(feature, index) in features" 
            :key="index"
            class="feature-card"
            :class="{ 'feature-card-active': activeFeature === index }"
            @mouseenter="activeFeature = index"
          >
            <div class="feature-icon-wrapper">
              <el-icon class="feature-icon" :size="48">
                <component :is="iconMap[feature.icon] || feature.icon" />
              </el-icon>
              <div class="feature-glow"></div>
            </div>
            <h3 class="feature-title">{{ feature.title }}</h3>
            <p class="feature-description">{{ feature.description }}</p>
            <ul class="feature-list">
              <li v-for="(item, i) in feature.items" :key="i">{{ item }}</li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <!-- 第三屏：智能拓客理念 -->
    <section class="philosophy-section" ref="philosophySection">
      <div class="section-container">
        <div class="philosophy-content">
          <div class="philosophy-text">
            <div class="philosophy-badge">核心理念</div>
            <h2 class="philosophy-title">以智慧拓客，与星光同行</h2>
            <p class="philosophy-description">
              在数字化时代，客户拓展不再是简单的数量积累，而是需要智慧的方法和精准的策略。
              智拓星销售管理系统，通过智能化的数据分析、流程化的管理方式，帮助您：
            </p>
            <div class="philosophy-points">
              <div class="philosophy-point">
                <div class="point-icon">✨</div>
                <div class="point-content">
                  <h4>智能识别</h4>
                  <p>通过数据分析，智能识别高价值客户，精准定位目标群体</p>
                </div>
              </div>
              <div class="philosophy-point">
                <div class="point-icon">🚀</div>
                <div class="point-content">
                  <h4>高效拓客</h4>
                  <p>系统化的客户管理流程，让拓客工作更加高效有序</p>
                </div>
              </div>
              <div class="philosophy-point">
                <div class="point-icon">💫</div>
                <div class="point-content">
                  <h4>星光同行</h4>
                  <p>全程陪伴，让每一次客户接触都闪耀价值，共同成长</p>
                </div>
              </div>
            </div>
          </div>
          <div class="philosophy-visual">
            <div class="philosophy-circle">
              <div class="circle-inner">
                <div class="circle-text">智慧</div>
                <div class="circle-text">拓客</div>
              </div>
              <div class="circle-rings">
                <div class="ring ring-1"></div>
                <div class="ring ring-2"></div>
                <div class="ring ring-3"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 第四屏：系统优势 -->
    <section class="advantages-section" ref="advantagesSection">
      <div class="section-container">
        <div class="section-header">
          <h2 class="section-title">为什么选择智拓星</h2>
          <p class="section-subtitle">企业「营销-销售-服务」一站式管理平台，携智拓星协同能力优势，助力商机转化、销售协同、客户满意度提升</p>
        </div>
        <div class="advantages-grid">
          <div 
            v-for="(advantage, index) in advantages" 
            :key="index"
            class="advantage-item"
          >
            <div class="advantage-icon">
              <el-icon :size="40">
                <component :is="iconMap[advantage.icon] || advantage.icon" />
              </el-icon>
            </div>
            <h3 class="advantage-title">{{ advantage.title }}</h3>
            <p class="advantage-description">{{ advantage.description }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 第五屏：登录表单区域 -->
    <section class="login-section" ref="loginSection">
      <div class="login-container-wrapper">
        <div class="login-left-panel">
          <div class="login-left-content">
            <h2 class="login-welcome-title">欢迎回来</h2>
            <p class="login-welcome-subtitle">登录智拓星，开启智能销售管理之旅</p>
            <div class="login-features-mini">
              <div class="mini-feature">
                <el-icon><User /></el-icon>
              <span>客户管理</span>
            </div>
              <div class="mini-feature">
                <el-icon><Document /></el-icon>
              <span>合同管理</span>
            </div>
              <div class="mini-feature">
                <el-icon><DataAnalysis /></el-icon>
              <span>数据分析</span>
            </div>
              <div class="mini-feature">
                <el-icon><Setting /></el-icon>
              <span>流程审批</span>
            </div>
          </div>
        </div>
      </div>
        <div class="login-right-panel">
        <div class="login-form-wrapper">
          <div class="login-header">
              <h2 class="login-title">登录账户</h2>
            <p class="login-subtitle">请使用您的账号密码登录系统</p>
          </div>

          <el-form
            ref="loginFormRef"
            :model="loginForm"
            :rules="loginRules"
            class="login-form"
            size="large"
          >
            <el-form-item prop="username" class="username-form-item">
              <el-input
                v-model="loginForm.username"
                placeholder="请输入用户名/工号"
                class="login-input"
                clearable
                @keyup.enter="handleLogin"
              >
                <template #prefix>
                  <el-icon><User /></el-icon>
                </template>
              </el-input>
              <a href="javascript:void(0)" class="forgot-password-link input-right-link" @click="openForgotPasswordDialog">
                忘记密码？
              </a>
            </el-form-item>

            <el-form-item prop="password">
              <el-input
                v-model="loginForm.password"
                type="password"
                placeholder="请输入密码"
                class="login-input"
                show-password
                @keyup.enter="handleLogin"
              >
                <template #prefix>
                  <el-icon><Lock /></el-icon>
                </template>
              </el-input>
            </el-form-item>

            <el-form-item class="remember-password-form-item">
              <div class="remember-password-wrapper">
                <el-checkbox v-model="rememberPassword" class="remember-password-checkbox">
                  记住密码
                </el-checkbox>
<!--                <div class="remember-password-tip">-->
<!--                  <el-icon><InfoFilled /></el-icon>-->
<!--                  <span>密码将加密存储在本设备，跨设备/浏览器需重新输入</span>-->
<!--                </div>-->
              </div>
            </el-form-item>

            <el-form-item>
              <el-button
                type="primary"
                class="login-button"
                :loading="loading"
                @click="handleLogin"
              >
                {{ loading ? '登录中...' : '立即登录' }}
              </el-button>
            </el-form-item>
          </el-form>

          <div class="login-footer">
            <div class="footer-content">
              <!-- 联系方式区域 -->
              <div class="footer-contact-section">
                <div class="footer-contact-item">
                  <span class="footer-label">交流答疑QQ群：</span>
                  <span class="footer-value">733363054、765767451</span>
                </div>
                <div class="footer-contact-item">
                  <span class="footer-label">商务联系：</span>
                  <a
                      href="javascript:void(0)"
                      class="footer-link wechat-link"
                      @click="handleWechatClick"
                  >
                    15261106859
                  </a>
                  <span class="footer-note">(微信同号)</span>
                </div>
              </div>
              
              <!-- 分隔线 -->
              <div class="footer-divider"></div>
              
              <!-- 版权信息区域 -->
              <div class="footer-copyright-section">
                <div class="footer-copyright-item">
                  <span class="copyright">© 2025 常州智之星网络科技有限公司 版权所有</span>
                </div>
                <div class="footer-copyright-item">
                  <a 
                    href="javascript:void(0)" 
                    class="icp-link"
                    @click="handleIcpClick"
                  >
                    苏ICP备2025228354号
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 忘记密码说明弹窗（仅提示，不做自助重置） -->
    <el-dialog
      v-model="forgotPasswordDialogVisible"
      title="忘记密码"
      width="420px"
      :close-on-click-modal="true"
      :show-close="true"
    >
      <div class="forgot-password-tip">
        忘记密码请联系<span class="highlight">系统管理员或企业管理员</span>，
        由管理员在后台为您重置密码。
      </div>
      <div class="forgot-password-notice">
        <p>· 为了保障账号安全，当前系统暂不支持自助重置密码。</p>
        <p>· 管理员重置后，请您登录系统并及时修改为更安全的密码。</p>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="forgotPasswordDialogVisible = false">我知道了</el-button>
        </span>
      </template>
    </el-dialog>
    </section>

    <!-- 回到顶部按钮 -->
    <div
      v-if="showBackTop"
      class="back-to-top"
      @click="scrollToTop"
    >
      <span class="arrow">↑</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoginPage'
}
</script>

<script setup>
import { ref, reactive, onMounted, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
import { 
  User, Lock, Document, DataAnalysis, Setting,
  TrendCharts, Share, Star, Clock, Monitor,
  Folder, ChatLineRound, DataLine, Connection,
  InfoFilled
} from '@element-plus/icons-vue'
import { login } from '../api/auth'
import { 
  saveRememberedPassword, 
  getRememberedPassword, 
  clearRememberedPassword 
} from '../utils/rememberPassword'

const router = useRouter()

// 图标映射对象 - 将字符串名称映射到实际导入的图标组件
const iconMap = {
  User,
  Lock,
  Document,
  DataAnalysis,
  Setting,
  TrendCharts,
  Share,
  Star,
  Clock,
  Monitor,
  Folder,
  ChatLineRound,
  DataLine,
  Connection,
  InfoFilled
}

// 表单引用
const loginFormRef = ref(null)
const loading = ref(false)

// 忘记密码说明弹窗
const forgotPasswordDialogVisible = ref(false)

const openForgotPasswordDialog = () => {
  forgotPasswordDialogVisible.value = true
}
const activeFeature = ref(0)

// 是否显示回到顶部按钮
const showBackTop = ref(false)

// 登录表单数据
const loginForm = reactive({
  username: '',
  password: ''
})

// 记住密码
const rememberPassword = ref(false)

// 表单验证规则
const loginRules = {
  username: [
    { required: true, message: '请输入用户名/工号', trigger: 'blur' }
  ],
  password: [
    { required: true, message: '请输入密码', trigger: 'blur' },
    { min: 6, message: '密码长度不能少于6位', trigger: 'blur' }
  ]
}

// 核心功能数据
const features = [
  {
    icon: 'User',
    title: '客户管理',
    description: '全方位客户信息管理，建立完整的客户档案',
    items: ['客户信息录入', '客户分类管理', '跟进记录追踪', '客户价值分析']
  },
  {
    icon: 'Document',
    title: '合同管理',
    description: '合同全生命周期管理，规范合同审批流程',
    items: ['合同在线创建', '审批流程配置', '合同状态跟踪', '合同数据留存']
  },
  {
    icon: 'DataAnalysis',
    title: '数据分析',
    description: '智能数据分析，洞察销售趋势和业务机会',
    items: ['销售数据统计', '业绩趋势分析', '客户画像分析', '预测性分析']
  },
  {
    icon: 'Setting',
    title: '流程审批',
    description: '灵活的审批流程配置，提升审批效率',
    items: ['自定义审批流', '多级审批支持', '审批历史记录', '移动端审批']
  }
]

// 系统优势数据
const advantages = [
  {
    icon: 'Folder',
    title: '客户资产管理难',
    description: '提供客户数字化档案，客户资料与动态不丢失'
  },
  {
    icon: 'ChatLineRound',
    title: '销售协同效率低',
    description: '提供销售场景群，助力销售团队高效沟通与协作'
  },
  {
    icon: 'DataLine',
    title: '销售工作不量化',
    description: '跟进动作全程数字化，跟进风险实时计算和预警'
  },
  {
    icon: 'Connection',
    title: '业务场域连接弱',
    description: '主数据打通,实现营销、销售、服务业务一体化'
  }
]

// 获取星星样式
const getStarStyle = (index) => {
  const size = Math.random() * 3 + 1
  const left = Math.random() * 100
  const top = Math.random() * 100
  const delay = Math.random() * 3
  const duration = Math.random() * 2 + 2
  
  return {
    width: `${size}px`,
    height: `${size}px`,
    left: `${left}%`,
    top: `${top}%`,
    animationDelay: `${delay}s`,
    animationDuration: `${duration}s`
  }
}

// 获取网络节点样式
const getNodeStyle = (index) => {
  const angle = (index / 12) * Math.PI * 2
  const radius = 120
  const x = Math.cos(angle) * radius
  const y = Math.sin(angle) * radius
  
  return {
    transform: `translate(${x}px, ${y}px)`
  }
}

// 滚动到登录区域
const scrollToLogin = () => {
  const loginSection = document.querySelector('.login-section')
  if (loginSection) {
    loginSection.scrollIntoView({ behavior: 'smooth' })
  }
}

// 回到顶部
const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  })
}

// 滚动监听，实现视差效果 + 回到顶部按钮显示控制
let scrollHandler = null
onMounted(() => {
  scrollHandler = () => {
    const scrollY = window.scrollY
    const heroSection = document.querySelector('.hero-section')
    if (heroSection) {
      heroSection.style.transform = `translateY(${scrollY * 0.5}px)`
    }

    // 当滚动超过一屏高度时显示回到顶部按钮
    showBackTop.value = scrollY > window.innerHeight * 0.6
  }
  window.addEventListener('scroll', scrollHandler)
  
  // 加载记住的密码
  loadRememberedPassword()
})

/**
 * 加载记住的密码
 */
const loadRememberedPassword = () => {
  try {
    const remembered = getRememberedPassword()
    if (remembered && remembered.username && remembered.password) {
      loginForm.username = remembered.username
      loginForm.password = remembered.password
      rememberPassword.value = true
      console.log('已加载记住的密码')
    }
  } catch (error) {
    console.error('加载记住密码失败:', error)
    // 如果加载失败（可能是跨设备），清除记住的密码
    clearRememberedPassword()
  }
}

onUnmounted(() => {
  if (scrollHandler) {
    window.removeEventListener('scroll', scrollHandler)
  }
})

// 处理备案号点击
const handleIcpClick = (e) => {
  e.preventDefault()
  const icpNumber = '苏ICP备2025228354号'
  const queryUrl = `https://beian.miit.gov.cn/#/Integrated/index?q=${encodeURIComponent(icpNumber)}`
  window.open(queryUrl, '_blank')
  return false
}

// 处理微信/手机号点击
const handleWechatClick = async (e) => {
  e.preventDefault()
  const phoneNumber = '15261106859'
  
  try {
    // 1. 先复制手机号到剪贴板
    if (navigator.clipboard && navigator.clipboard.writeText) {
      await navigator.clipboard.writeText(phoneNumber)
    } else {
      // 降级方案：使用传统方法复制
      const textArea = document.createElement('textarea')
      textArea.value = phoneNumber
      textArea.style.position = 'fixed'
      textArea.style.opacity = '0'
      document.body.appendChild(textArea)
      textArea.select()
      document.execCommand('copy')
      document.body.removeChild(textArea)
    }
    
    // 2. 尝试打开微信PC版
    // 微信PC版的URL协议，尝试打开微信客户端
    try {
      // 尝试使用微信协议打开（如果微信已安装）
      window.location.href = 'weixin://'
      
      // 延迟显示提示，给微信打开时间
      setTimeout(() => {
        ElMessage.success({
          message: '手机号已复制，请在微信中搜索添加',
          duration: 3000,
          showClose: true
        })
      }, 500)
    } catch (wechatError) {
      // 如果无法打开微信，只显示复制成功的提示
      ElMessage.success({
        message: '手机号已复制，请在微信中搜索添加',
        duration: 3000,
        showClose: true
      })
    }
  } catch (error) {
    console.error('复制失败:', error)
    // 如果复制失败，尝试直接打开微信
    try {
      window.location.href = 'weixin://'
      ElMessage.info({
        message: '正在打开微信，请在微信中搜索：15261106859',
        duration: 3000,
        showClose: true
      })
    } catch (wechatError) {
      ElMessage.warning({
        message: '请手动打开微信，搜索手机号：15261106859',
        duration: 4000,
        showClose: true
      })
    }
  }
}

// 处理登录
const handleLogin = async () => {
  if (!loginFormRef.value) return

  await loginFormRef.value.validate(async (valid) => {
    if (!valid) return

    loading.value = true
    try {
      const response = await login(loginForm)
      
      if (response.code === '000000' && response.data) {
        let oldUserId = null
        try {
          const oldUserInfoStr = localStorage.getItem('userInfo')
          if (oldUserInfoStr) {
            const oldUserInfo = JSON.parse(oldUserInfoStr)
            oldUserId = oldUserInfo?.userId || null
          }
        } catch (e) {
          console.warn('解析旧用户信息失败:', e)
        }
        if (oldUserId) {
          localStorage.removeItem(`unreadMessageAlert_${oldUserId}`)
        }
        
        const newUserId = response.data.userId
        if (newUserId) {
          localStorage.removeItem(`unreadMessageAlert_${newUserId}`)
        }
        
        // 检查会员状态（PC系统仅开放给会员用户）
        const isMember = response.data.isMember
        const memberLevel = response.data.memberLevel
        
        // 如果用户不是会员或会员信息缺失，显示提示并阻止登录
        if (!isMember || isMember === 0 || !memberLevel) {
          // 清除已保存的token和用户信息
          localStorage.removeItem('accessToken')
          localStorage.removeItem('refreshToken')
          localStorage.removeItem('userInfo')
          
          // 显示弹窗提示
          ElMessageBox.alert('该系统仅开放给会员用户，您可以升级会员享用权益！', '会员提示', {
            confirmButtonText: '确定',
            type: 'warning',
            center: true
          }).then(() => {
            // 用户点击确定后，停留在登录页
          }).catch(() => {
            // 用户关闭弹窗后，停留在登录页
          })
          return
        }
        
        localStorage.setItem('accessToken', response.data.accessToken)
        localStorage.setItem('refreshToken', response.data.refreshToken)
        localStorage.setItem('userInfo', JSON.stringify({
          userId: response.data.userId,
          username: response.data.username,
          realName: response.data.realName,
          userType: response.data.userType,
          companyId: response.data.companyId,
          roles: response.data.roles,
          permissions: response.data.permissions,
          menus: response.data.menus,
          isMember: response.data.isMember,
          membershipId: response.data.membershipId,
          memberLevel: response.data.memberLevel
        }))

        // 处理记住密码
        if (rememberPassword.value) {
          // 勾选了记住密码，保存用户名和密码
          try {
            saveRememberedPassword(loginForm.username, loginForm.password)
          } catch (error) {
            console.error('保存记住密码失败:', error)
            // 保存失败不影响登录流程
          }
        } else {
          // 未勾选记住密码，清除已保存的密码
          clearRememberedPassword()
        }
        
        ElMessage.success('登录成功')
        router.push('/home')
      }
    } catch (error) {
      console.error('登录错误:', error)
      
      // 处理会员状态相关的错误（后端返回的会员限制错误）
      if (error.response && error.response.status === 400) {
        const errorData = error.response.data
        if (errorData && errorData.msg) {
          const errorMsg = errorData.msg
          // 如果是会员相关的错误，显示弹窗提示
          if (errorMsg.includes('会员') || errorMsg.includes('该系统仅开放给会员用户')) {
            ElMessageBox.alert(errorMsg, '会员提示', {
              confirmButtonText: '确定',
              type: 'warning',
              center: true
            }).then(() => {
              // 用户点击确定后，停留在登录页
            }).catch(() => {
              // 用户关闭弹窗后，停留在登录页
            })
            return
          }
          
          // 其他错误显示普通消息提示
          if (errorData && errorData.data) {
            const errors = errorData.data
            const errorMessages = Object.keys(errors).map(key => `${key}: ${errors[key]}`).join('\n')
            ElMessage.error('登录失败：\n' + errorMessages)
          } else {
            ElMessage.error(errorMsg)
          }
        } else if (errorData && errorData.data) {
          const errors = errorData.data
          const errorMessages = Object.keys(errors).map(key => `${key}: ${errors[key]}`).join('\n')
          ElMessage.error('登录失败：\n' + errorMessages)
        }
      } else if (error.message && (error.message.includes('会员') || error.message.includes('该系统仅开放给会员用户'))) {
        // 处理非HTTP错误中的会员相关错误
        ElMessageBox.alert(error.message, '会员提示', {
          confirmButtonText: '确定',
          type: 'warning',
          center: true
        }).then(() => {
          // 用户点击确定后，停留在登录页
        }).catch(() => {
          // 用户关闭弹窗后，停留在登录页
        })
        return
      } else {
        // 其他未知错误
        ElMessage.error('登录失败，请重试')
      }
    } finally {
      loading.value = false
    }
  })
}
</script>

<style scoped>
.login-landing-page {
  width: 100%;
  min-height: 100vh;
  background: #0a0e27;
  color: #fff;
  overflow-x: hidden;
  position: relative;
}

/* 固定导航栏 */
.fixed-navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: rgba(10, 14, 39, 0.8);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  transition: all 0.3s ease;
}

.navbar-content {
  max-width: 1400px;
  margin: 0 auto;
  padding: 20px 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo-section {
  display: flex;
  align-items: center;
  gap: 12px;
}

.logo-text {
  font-size: 28px;
  font-weight: 700;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin: 0;
}

.logo-subtitle {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
}

.login-btn-nav {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  padding: 10px 24px;
  font-weight: 600;
  transition: all 0.3s ease;
}

.login-btn-nav:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(102, 126, 234, 0.4);
}

/* 星光背景 */
.stars-background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  pointer-events: none;
}

.star {
  position: absolute;
  background: #fff;
  border-radius: 50%;
  animation: twinkle linear infinite;
  box-shadow: 0 0 6px rgba(255, 255, 255, 0.8);
}

@keyframes twinkle {
  0%, 100% {
    opacity: 0.3;
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(1.2);
  }
}

/* Hero区域 */
.hero-section {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 120px 40px 80px;
  z-index: 2;
}

.hero-content {
  max-width: 1400px;
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 80px;
  align-items: center;
}

.hero-text-wrapper {
  animation: fadeInUp 1s ease-out;
}

.hero-title {
  font-size: 64px;
  font-weight: 800;
  line-height: 1.2;
  margin: 0 0 24px 0;
  background: linear-gradient(135deg, #fff 0%, #667eea 50%, #f093fb 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.title-line-1,
.title-line-2 {
  display: block;
}

.title-line-2 {
  margin-top: 12px;
}

.hero-subtitle {
  font-size: 24px;
  color: rgba(255, 255, 255, 0.9);
  margin: 0 0 20px 0;
  font-weight: 500;
}

.hero-description {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.7);
  line-height: 1.8;
  margin: 0 0 40px 0;
}

.hero-stats {
  display: flex;
  gap: 40px;
  margin-top: 40px;
}

.stat-item {
  text-align: center;
}

.stat-number {
  font-size: 36px;
  font-weight: 700;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 8px;
}

.stat-label {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6);
}

.hero-visual {
  position: relative;
  width: 100%;
  height: 500px;
  animation: fadeInRight 1s ease-out;
}

.glow-orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(60px);
  opacity: 0.6;
  animation: float 6s ease-in-out infinite;
}

.orb-1 {
  width: 200px;
  height: 200px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  top: 10%;
  left: 20%;
  animation-delay: 0s;
}

.orb-2 {
  width: 150px;
  height: 150px;
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
  top: 50%;
  right: 20%;
  animation-delay: 2s;
}

.orb-3 {
  width: 180px;
  height: 180px;
  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
  bottom: 10%;
  left: 50%;
  animation-delay: 4s;
}

@keyframes float {
  0%, 100% {
    transform: translate(0, 0) scale(1);
  }
  33% {
    transform: translate(30px, -30px) scale(1.1);
  }
  66% {
    transform: translate(-20px, 20px) scale(0.9);
  }
}

.network-visual {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 300px;
  height: 300px;
}

.network-node {
  position: absolute;
  width: 12px;
  height: 12px;
  background: #667eea;
  border-radius: 50%;
  box-shadow: 0 0 20px rgba(102, 126, 234, 0.8);
  animation: pulse-node 2s ease-in-out infinite;
}

.network-node:nth-child(odd) {
  animation-delay: 0.5s;
}

@keyframes pulse-node {
  0%, 100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.5);
    opacity: 0.7;
  }
}

.network-lines {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  border: 2px solid rgba(102, 126, 234, 0.3);
  border-radius: 50%;
  animation: rotate 20s linear infinite;
}

@keyframes rotate {
  from {
    transform: translate(-50%, -50%) rotate(0deg);
  }
  to {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}

.scroll-indicator {
  position: absolute;
  bottom: 40px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  animation: bounce 2s infinite;
}

.scroll-mouse {
  width: 24px;
  height: 40px;
  border: 2px solid rgba(255, 255, 255, 0.5);
  border-radius: 12px;
  position: relative;
}

.scroll-wheel {
  width: 4px;
  height: 8px;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 2px;
  position: absolute;
  top: 8px;
  left: 50%;
  transform: translateX(-50%);
  animation: scroll-wheel 1.5s infinite;
}

@keyframes scroll-wheel {
  0% {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
  100% {
    opacity: 0;
    transform: translateX(-50%) translateY(16px);
  }
}

.scroll-text {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6);
}

@keyframes bounce {
  0%, 100% {
    transform: translateX(-50%) translateY(0);
  }
  50% {
    transform: translateX(-50%) translateY(-10px);
  }
}

/* 功能展示区域 */
.features-section {
  min-height: 100vh;
  padding: 120px 40px;
  position: relative;
  z-index: 2;
  background: linear-gradient(180deg, #0a0e27 0%, #1a1f3a 100%);
}

.section-container {
  max-width: 1400px;
  margin: 0 auto;
}

.section-header {
  text-align: center;
  margin-bottom: 80px;
}

.section-title {
  font-size: 48px;
  font-weight: 700;
  margin: 0 0 16px 0;
  background: linear-gradient(135deg, #fff 0%, #667eea 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.section-subtitle {
  font-size: 18px;
  color: rgba(255, 255, 255, 0.7);
  margin: 0;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 30px;
}

.feature-card {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  padding: 40px;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  backdrop-filter: blur(10px);
  position: relative;
  overflow: hidden;
}

.feature-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%);
  opacity: 0;
  transition: opacity 0.4s ease;
}

.feature-card:hover::before,
.feature-card-active::before {
  opacity: 1;
}

.feature-card:hover,
.feature-card-active {
  transform: translateY(-10px);
  border-color: rgba(102, 126, 234, 0.5);
  box-shadow: 0 20px 40px rgba(102, 126, 234, 0.2);
}

.feature-icon-wrapper {
  position: relative;
  margin-bottom: 24px;
  display: inline-block;
}

.feature-icon {
  color: #667eea;
  position: relative;
  z-index: 2;
  transition: all 0.4s ease;
}

.feature-card:hover .feature-icon,
.feature-card-active .feature-icon {
  transform: scale(1.1) rotate(5deg);
  color: #764ba2;
}

.feature-glow {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80px;
  height: 80px;
  background: radial-gradient(circle, rgba(102, 126, 234, 0.3) 0%, transparent 70%);
  border-radius: 50%;
  opacity: 0;
  transition: opacity 0.4s ease;
}

.feature-card:hover .feature-glow,
.feature-card-active .feature-glow {
  opacity: 1;
}

.feature-title {
  font-size: 24px;
  font-weight: 600;
  margin: 0 0 12px 0;
  color: #fff;
}

.feature-description {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.7);
  margin: 0 0 20px 0;
  line-height: 1.6;
}

.feature-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.feature-list li {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6);
  padding: 8px 0;
  padding-left: 24px;
  position: relative;
}

.feature-list li::before {
  content: '✓';
  position: absolute;
  left: 0;
  color: #667eea;
  font-weight: bold;
}

/* 理念展示区域 */
.philosophy-section {
  min-height: 100vh;
  padding: 120px 40px;
  position: relative;
  z-index: 2;
  background: linear-gradient(180deg, #1a1f3a 0%, #0a0e27 100%);
}

.philosophy-content {
  max-width: 1400px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 80px;
  align-items: center;
}

.philosophy-badge {
  display: inline-block;
  padding: 8px 20px;
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.2) 0%, rgba(118, 75, 162, 0.2) 100%);
  border: 1px solid rgba(102, 126, 234, 0.3);
  border-radius: 20px;
  font-size: 14px;
  color: #667eea;
  margin-bottom: 24px;
}

.philosophy-title {
  font-size: 48px;
  font-weight: 700;
  margin: 0 0 24px 0;
  background: linear-gradient(135deg, #fff 0%, #667eea 50%, #f093fb 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  line-height: 1.2;
}

.philosophy-description {
  font-size: 18px;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.8;
  margin: 0 0 40px 0;
}

.philosophy-points {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.philosophy-point {
  display: flex;
  gap: 20px;
  align-items: flex-start;
}

.point-icon {
  font-size: 32px;
  flex-shrink: 0;
}

.point-content h4 {
  font-size: 20px;
  font-weight: 600;
  margin: 0 0 8px 0;
  color: #fff;
}

.point-content p {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.7);
  margin: 0;
  line-height: 1.6;
}

.philosophy-visual {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.philosophy-circle {
  position: relative;
  width: 400px;
  height: 400px;
}

.circle-inner {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  z-index: 3;
}

.circle-text {
  font-size: 36px;
  font-weight: 700;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin: 8px 0;
}

.circle-rings {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
}

.ring {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border: 2px solid rgba(102, 126, 234, 0.3);
  border-radius: 50%;
  animation: rotate-ring linear infinite;
}

.ring-1 {
  width: 200px;
  height: 200px;
  animation-duration: 20s;
}

.ring-2 {
  width: 300px;
  height: 300px;
  animation-duration: 25s;
  animation-direction: reverse;
}

.ring-3 {
  width: 400px;
  height: 400px;
  animation-duration: 30s;
}

@keyframes rotate-ring {
  from {
    transform: translate(-50%, -50%) rotate(0deg);
  }
  to {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}

/* 优势展示区域 */
.advantages-section {
  min-height: 100vh;
  padding: 120px 40px;
  position: relative;
  z-index: 2;
  background: linear-gradient(180deg, #0a0e27 0%, #1a1f3a 100%);
}

.advantages-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 30px;
  max-width: 1000px;
  margin: 0 auto;
}

.advantage-item {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  padding: 40px;
  text-align: center;
  transition: all 0.4s ease;
  backdrop-filter: blur(10px);
}

.advantage-item:hover {
  transform: translateY(-10px);
  border-color: rgba(102, 126, 234, 0.5);
  box-shadow: 0 20px 40px rgba(102, 126, 234, 0.2);
  background: rgba(255, 255, 255, 0.08);
}

.advantage-icon {
  color: #667eea;
  margin-bottom: 20px;
  transition: all 0.4s ease;
}

.advantage-item:hover .advantage-icon {
  transform: scale(1.2) rotate(5deg);
  color: #764ba2;
}

.advantage-title {
  font-size: 22px;
  font-weight: 600;
  margin: 0 0 16px 0;
  color: #fff;
  line-height: 1.4;
}

.advantage-description {
  font-size: 15px;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.7;
  margin: 0;
}

/* 登录区域 */
.login-section {
  min-height: 100vh;
  padding: 120px 40px 80px;
  position: relative;
  z-index: 2;
  background: linear-gradient(180deg, #1a1f3a 0%, #0a0e27 100%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-container-wrapper {
  max-width: 1200px;
  width: 100%;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 30px;
  overflow: hidden;
  backdrop-filter: blur(20px);
  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.3);
  display: grid;
  grid-template-columns: 1fr 1fr;
}

.login-left-panel {
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.2) 0%, rgba(118, 75, 162, 0.2) 100%);
  padding: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}

.login-left-panel::before {
  content: '';
  position: absolute;
  top: -50%;
  right: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.1) 0%, transparent 70%);
  animation: pulse 8s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
    opacity: 0.5;
  }
  50% {
    transform: scale(1.1);
    opacity: 0.8;
  }
}

.login-left-content {
  position: relative;
  z-index: 2;
  text-align: center;
}

.login-welcome-title {
  font-size: 42px;
  font-weight: 700;
  margin: 0 0 16px 0;
  color: #fff;
}

.login-welcome-subtitle {
  font-size: 18px;
  color: rgba(255, 255, 255, 0.9);
  margin: 0 0 40px 0;
}

.login-features-mini {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  margin-top: 40px;
}

.mini-feature {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  color: #fff;
  font-size: 14px;
  transition: all 0.3s ease;
}

.mini-feature:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: translateY(-2px);
}

.mini-feature .el-icon {
  font-size: 20px;
}

.login-right-panel {
  background: rgba(255, 255, 255, 0.98);
  padding: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-form-wrapper {
  width: 100%;
  max-width: 400px;
}

.login-header {
  text-align: center;
  margin-bottom: 40px;
}

.login-title {
  font-size: 32px;
  font-weight: 600;
  color: #333;
  margin: 0 0 10px 0;
}

.login-subtitle {
  font-size: 14px;
  color: #999;
  margin: 0;
}

.login-form {
  margin-top: 30px;
}

.forgot-password-link {
  font-size: 14px;
  color: #409eff;
  text-decoration: none;
  cursor: pointer;
  white-space: nowrap;
}

.forgot-password-link:hover {
  text-decoration: underline;
}

.login-input {
  width: 100%;
}

.username-form-item {
  position: relative;
}

.input-right-link {
  position: absolute;
  right: 4px;
  top: -30px;
}

.login-input :deep(.el-input__wrapper) {
  border-radius: 8px;
  padding: 12px 15px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
}

.login-input :deep(.el-input__wrapper:hover) {
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);
}

.login-input :deep(.el-input__wrapper.is-focus) {
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.login-button {
  width: 100%;
  height: 50px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 8px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  transition: all 0.3s ease;
}

.login-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(102, 126, 234, 0.4);
}

.login-button:active {
  transform: translateY(0);
}

.login-footer {
  margin-top: 50px;
  padding-top: 30px;
  border-top: 1px solid #f0f0f0;
  position: relative;
}

.login-footer::before {
  content: '';
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 2px;
  background: linear-gradient(90deg, transparent, #667eea, transparent);
  border-radius: 2px;
}

.footer-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  width: 100%;
}

/* 联系方式区域 */
.footer-contact-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  width: 100%;
}

.footer-contact-item {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 6px;
  line-height: 1.8;
}

.footer-label {
  font-size: 13px;
  color: #666;
  font-weight: 500;
}

.footer-value {
  font-size: 13px;
  color: #333;
  font-weight: 500;
}

.footer-link {
  font-size: 13px;
  color: #667eea;
  text-decoration: none;
  transition: all 0.3s ease;
  font-weight: 500;
  padding: 2px 6px;
  border-radius: 4px;
}

.footer-link:hover {
  color: #764ba2;
  background: rgba(102, 126, 234, 0.08);
  text-decoration: none;
}

.footer-note {
  font-size: 12px;
  color: #999;
  margin-left: 4px;
}

/* 分隔线 */
.footer-divider {
  width: 100%;
  max-width: 300px;
  height: 1px;
  background: linear-gradient(90deg, transparent, #e0e0e0, transparent);
  margin: 8px 0;
}

/* 版权信息区域 */
.footer-copyright-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  width: 100%;
}

.footer-copyright-item {
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1.6;
}

.copyright {
  font-size: 12px;
  color: #999;
  margin: 0;
  letter-spacing: 0.3px;
}

.forgot-password-tip {
  font-size: 14px;
  color: #666;
  margin-bottom: 16px;
}

.forgot-password-tip .highlight {
  color: #ff4d4f;
  font-weight: 600;
}

.forgot-password-form :deep(.el-input__wrapper) {
  width: 260px;
}

.forgot-password-notice {
  margin-top: 12px;
  font-size: 12px;
  color: #999;
  line-height: 1.6;
}

.icp-link {
  font-size: 12px;
  color: #999;
  text-decoration: none;
  transition: all 0.3s ease;
  cursor: pointer;
  position: relative;
  padding: 4px 8px;
  border-radius: 4px;
  display: inline-block;
}

.icp-link:hover {
  color: #667eea;
  background: rgba(102, 126, 234, 0.08);
}

.icp-link::after {
  content: '';
  position: absolute;
  bottom: 2px;
  left: 8px;
  right: 8px;
  height: 1px;
  background: linear-gradient(90deg, transparent, #667eea, transparent);
  transform: scaleX(0);
  transition: transform 0.3s ease;
}

.icp-link:hover::after {
  transform: scaleX(1);
}

/* 记住密码样式 */
.remember-password-form-item {
  margin-bottom: 12px !important; /* 减少和按钮之间的间距 */
}

.remember-password-wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end; /* 右对齐 */
  gap: 8px;
}

.remember-password-checkbox {
  align-self: flex-end; /* 复选框右对齐 */
}

.remember-password-checkbox :deep(.el-checkbox__label) {
  font-size: 14px;
  color: #666;
}

.remember-password-tip {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #999;
  margin-top: -4px;
  text-align: right; /* 提示文字右对齐 */
}

.remember-password-tip .el-icon {
  font-size: 14px;
  color: #409eff;
}

.remember-password-tip span {
  line-height: 1.4;
}

/* 回到顶部按钮 */
.back-to-top {
  position: fixed;
  right: 80px;
  bottom: 40px;
  width: 46px;
  height: 46px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  box-shadow: 0 8px 20px rgba(102, 126, 234, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 1100;
  transition: all 0.3s ease;
}

.back-to-top .arrow {
  color: #fff;
  font-size: 20px;
  line-height: 1;
}

.back-to-top:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 30px rgba(102, 126, 234, 0.6);
}

/* 动画 */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInRight {
  from {
    opacity: 0;
    transform: translateX(30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .hero-content,
  .philosophy-content {
    grid-template-columns: 1fr;
    gap: 40px;
  }

  .features-grid {
    grid-template-columns: 1fr;
  }

  .advantages-grid {
    grid-template-columns: repeat(2, 1fr);
    max-width: 900px;
  }

  .login-container-wrapper {
    grid-template-columns: 1fr;
  }

  .login-left-panel {
    padding: 40px;
  }
}

@media (max-width: 768px) {
  .hero-title {
    font-size: 42px;
  }

  .hero-subtitle {
    font-size: 18px;
  }

  .section-title {
    font-size: 36px;
  }

  .philosophy-title {
    font-size: 36px;
  }

  .advantages-grid {
    grid-template-columns: 1fr;
  }

  .navbar-content {
    padding: 15px 20px;
  }

  .logo-text {
    font-size: 24px;
  }

  .logo-subtitle {
    display: none;
  }

  .hero-section,
  .features-section,
  .philosophy-section,
  .advantages-section,
  .login-section {
    padding: 100px 20px 60px;
  }

  .hero-visual {
    height: 300px;
  }

  .philosophy-circle {
    width: 300px;
    height: 300px;
  }
}
</style>
